/*


  Modified by Taran Sahota
  Dated : 9/19/2019

  added form reducer - required for Redux Form to work

*/

import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

export const rootReducer = combineReducers({
    form: formReducer
});
